import localStorageIds from '../constants/localStorageIds'
import localStorageHelper from './localStorageHelper'

// The selected org's id, for the org routes of screens that act in the selected org.
const selectedOrgId = () => localStorageHelper(localStorageIds.SELECTED_ORG).localStorageValue?.id

export default selectedOrgId
